import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import StudentCard from './StudentCard';

export default function StudentGrid({ students, onStudentClick, busyStudentId }) {
  if (!students?.length) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography sx={{ fontWeight: 800, color: '#475569' }}>Bu sınıfta aktif öğrenci bulunamadı.</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: 'repeat(2, minmax(0, 1fr))',
          sm: 'repeat(3, minmax(0, 1fr))',
          md: 'repeat(4, minmax(0, 1fr))',
          lg: 'repeat(6, minmax(0, 1fr))',
          xl: 'repeat(8, minmax(0, 1fr))',
        },
        gap: { xs: 1.4, sm: 1.6, md: 2 },
        alignItems: 'stretch',
      }}
    >
      {students.map((student) => (
        <StudentCard
          key={student.id}
          student={student}
          disabled={Boolean(busyStudentId)}
          onClick={() => onStudentClick(student)}
        />
      ))}
    </Box>
  );
}
